import { Card as CardType, CurseTypes } from "../types";

interface CurseCard extends CardType {
  activity: CurseTypes | "other";
}

export const CURSE_CARDS: CurseCard[] = [
  {
    description:
      "You must speak in a sexy voice until your next turn (Breaking it causes the penalty)",
    penaltyCost: 2,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You must sit on someone's lap until your next turn (Breaking it causes the penalty)",
    penaltyCost: 3,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You must give someone a sensual massage until your next turn (Breaking it causes the penalty)",
    penaltyCost: 4,
    genre: "curse",
    activity: "other",
  },
  {
    description:
      "You must keep your hand on someone's thigh until your next turn (Breaking it causes the penalty)",
    penaltyCost: 3,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You must give someone a back rub until your next turn (Breaking it causes the penalty)",
    penaltyCost: 3,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You must keep your arm around someone's waist until your next turn (Breaking it causes the penalty)",
    penaltyCost: 2,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You must give someone a foot massage until your next turn (Breaking it causes the penalty)",
    penaltyCost: 3,
    genre: "curse",
    activity: "other",
  },
  {
    description:
      "You must keep your hand on someone's shoulder until your next turn (Breaking it causes the penalty)",
    penaltyCost: 2,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You must give someone a neck massage until your next turn (Breaking it causes the penalty)",
    penaltyCost: 3,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You must keep your hand on someone's arm until your next turn (Breaking it causes the penalty)",
    penaltyCost: 2,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You must give someone a scalp massage until your next turn (Breaking it causes the penalty)",
    penaltyCost: 3,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You must keep your hand on someone's hand until your next turn (Breaking it causes the penalty)",
    penaltyCost: 2,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You must give someone a shoulder massage until your next turn (Breaking it causes the penalty)",
    penaltyCost: 3,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You must keep your hand on someone's knee until your next turn (Breaking it causes the penalty)",
    penaltyCost: 2,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You must give someone a hand massage until your next turn (Breaking it causes the penalty)",
    penaltyCost: 2,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You must speak in an accent of the group's choosing until your next turn.",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    description:
      "Close your eyes until your next go (Breaking it causes the penalty)",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      'Only able to say "Yes" until your next go (Breaking it causes the penalty)',
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Can only whisper until your next go (Breaking it causes the penalty)",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Repeat everything the person to the right says until your next go (Breaking it causes the penalty)",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "The group chooses the animal for you to talk as until your next go  (Breaking it causes the penalty)",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Sing instead of talking until your next go  (Breaking it causes the penalty)",
    penaltyCost: 2,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Talk as a roadman until your next go  (Breaking it causes the penalty)",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Talk as a valley girl until your next go  (Breaking it causes the penalty)",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You are now a poision detector for the person to your left. Before they drink they pour you some to try first. (Until your next go)",
    penaltyCost: 3,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "You are now a butler for the person to your left. Bring them their cards and drinks. (Until your next go)",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
  },
  {
    description: "Stand on one leg until your next go!",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description: "Dance until your next go!",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description: "Spin slowly until your next go!",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description: "Make out with your hand until your next go!",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description: "Only elephant noises until your next go!",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description: "Only woof/bark until your next go!",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description:
      "The person to your right now has control of your hands (until your next go).",
    penaltyCost: 3,
    genre: "curse",
    activity: "other",
  },
  {
    description: "Hum a song. (Until someone says the name of it)",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    description: "Do the Macarena. (Until your next go)",
    penaltyCost: 1,
    genre: "curse",
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description: "You cannot speak until your next turn.",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description: "You can't say anyone's name until your next turn.",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description: "You cannot refuse any dares until your next turn.",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You can only communicate in seductive whispers until your next turn.",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "Until your next turn, everyone in the group can ask you one dirty question.",
    penaltyCost: 4,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description: "You must flirt with every person until your next turn.",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You must speak in rhymes until your next turn—or drink every time you fail.",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You cannot use the word 'drink' for two rounds, or you take a sip each time you do.",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You must hold your drink in your non-dominant hand until your next turn.",
    penaltyCost: 1,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "Anytime someone says your name, you must take a sip. (Until your next turn)",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You can only answer yes-or-no questions until your next turn.",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You can only speak in questions until your next turn—or drink every time you fail.",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "Anytime someone laughs, you must take a sip. (Until your next turn)",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You must swap drinks with the person to your left until your next turn.",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You cannot make eye contact with anyone for the next round—or drink every time you do.",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "Anytime someone says 'cheers,' you must take an extra sip. (Until your next turn)",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "Anytime someone says 'uh' or 'um,' they point at you and you take a sip. (Until your next turn)",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You must clap after every sentence you speak until your next turn.",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "For the next round, you cannot use your hands for any reason—or drink every time you break the rule.",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You cannot use any words longer than 5 letters for the next round—or take a sip each time you do.",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "For the next round, you must refer to yourself in the third person.",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "Anytime someone drinks, you must cheer them on—or take a sip for forgetting.",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You must freeze like a statue for 15 seconds anytime someone says your name. If you fail, you drink.",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You are not allowed to ask questions for the next round—or take a sip each time you forget.",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You must balance something small (like a coaster) on your head until your next turn—or drink if it falls.",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "Anytime the group claps, you must clap twice—or take a sip for failing.",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "You cannot say 'yes' or 'no' until your next turn—or take a sip every time you do.",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "For the next round, you must respond with the phrase, 'That's interesting,' no matter what—or drink if you forget.",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "curse",
    description:
      "Sit on the person 5 to the left's lap until your next turn—or take the penalty.",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
];
